//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateLegales } from "@/typings/store/plugins/easyFirestore/legales";

const getters: GetterTree<StateLegales, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const legales = {
    firestorePath: "dev/v1/legales",
    firestoreRefType: "collection",
    moduleName: "legales",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default legales;
